import { render, staticRenderFns } from "./costTypeEdit.vue?vue&type=template&id=18feaacc&scoped=true"
import script from "./costTypeEdit.vue?vue&type=script&lang=js"
export * from "./costTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./costTypeEdit.vue?vue&type=style&index=0&id=18feaacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18feaacc",
  null
  
)

export default component.exports